module.exports = __webpack_public_path__ + "img/B1.efb038c3.png";